
export const niches = [
  {
    name: "Fitness Store",
    icon: "🏋️",
    description: "Équipement et accessoires de fitness",
    products: 30,
    price: 11
  },
  {
    name: "Clothing Store",
    icon: "👕",
    description: "Vêtements et accessoires de mode",
    products: 30,
    price: 11
  },
  {
    name: "Pets Store",
    icon: "🐕",
    description: "Produits pour animaux de compagnie",
    products: 30,
    price: 11
  },
  {
    name: "Cosmetics Store",
    icon: "💄",
    description: "Produits de beauté et cosmétiques",
    products: 30,
    price: 11
  },
  {
    name: "Home Goods Store",
    icon: "🏠",
    description: "Articles pour la maison",
    products: 30,
    price: 11
  },
  {
    name: "Electronics Store",
    icon: "🎧",
    description: "Produits électroniques",
    products: 30,
    price: 19
  },
  {
    name: "Babies Store",
    icon: "👶",
    description: "Produits pour bébés",
    products: 30,
    price: 19
  },
  {
    name: "Jewelry Store",
    icon: "💍",
    description: "Bijoux et accessoires",
    products: 30,
    price: 19
  },
  {
    name: "Wigs Store",
    icon: "💇",
    description: "Perruques et extensions capillaires",
    products: 30,
    price: 20
  },
  {
    name: "Premium Supplements Store",
    icon: "💪",
    description: "Suppléments et produits premium",
    products: 30,
    price: 49
  },
  {
    name: "General Store",
    icon: "🏪",
    description: "Plus de 100 produits variés",
    products: 100,
    price: 49
  }
];
